import React from 'react';

import NobleSection from '../components/Common/NobleSection';
import RoiCalculator from '../components/Common/RoiCalculator/RoiCalculator.js';
import RotatingMedia from '../components/Common/RotatingMedia.js';
import StylizedHeadlineCallout from '../components/Common/StylizedHeadlineCallout.js';
import TabbedContent from '../components/Common/TabbedContent';
import VideoBanner from '../components/HomePage/VideoBanner';
import AdditionalResources from '../components/PageSections/AdditionalResources.js';
import G2Quote from '../components/PageSections/G2Quote.js';
import HalfAndHalfContent from '../components/PageSections/HalfAndHalfContent';
import LogoSection from '../components/PageSections/LogoSection';
import SessionList from '../components/PageSections/sessionList';
import Testimonial from '../components/PageSections/Testimonial.js';
import ThreeUp from '../components/PageSections/ThreeUp';
import ZPattern from '../components/PageSections/ZPattern.js';
import {
  ContentfulComponentCallToAction,
  ContentfulComponentSimpleContent,
  ContentfulComponentTestimonial,
  ContentfulSectionCallout,
  ContentfulSectionCarousel,
  ContentfulSectionContentSection,
  ContentfulSectionGroupedItems,
  ContentfulSectionMarketoForm,
} from './section-builder';

export const sectionBuilder = (
  page,
  styles,
  pageType = '',
  pageContext = {},
  scrollRef = { current: undefined },
  onCtaClick = () => null
) => {
  return page.pageSections?.map((section, i) => {
    const isCampaignLP = pageType === 'campaign';
    switch (section.__typename) {
      case 'ContentfulSectionIntersectionMarker': {
        if (section.featureType === 'Product Tour Violator') {
          return (
            <VideoBanner cta={section.callToAction} colorTheme={section.sectionColorTheme} offset={section.offset} />
          );
        }
        if (section.featureType === 'Noble Widget') {
          return <NobleSection colorTheme={section.sectionColorTheme || section.colorTheme?.themeName} key={i} />;
        }
        return null;
      }

      case 'ContentfulSectionTabbedContent': {
        return (
          <TabbedContent
            key={i}
            heading={section.mainHeading}
            lede={section.lede?.lede}
            content={section.tabbedContent}
          />
        );
      }

      case 'ContentfulSectionContentSection': {
        return ContentfulSectionContentSection(section, i, styles, isCampaignLP);
      }
      case 'ContentfulSectionCallout': {
        return ContentfulSectionCallout(section, i, styles);
      }
      case 'ContentfulComponentSimpleContent': {
        return ContentfulComponentSimpleContent(section, i, styles);
      }
      case 'ContentfulJsonData': {
        return <SessionList section={section} />;
      }
      case 'ContentfulComponentTestimonial': {
        return ContentfulComponentTestimonial(section, i, styles);
      }
      case 'ContentfulSectionMarketoForm': {
        return ContentfulSectionMarketoForm(page, section, i, styles, scrollRef);
      }
      case 'ContentfulSectionGroupedItems': {
        return ContentfulSectionGroupedItems(page, section, i, styles, isCampaignLP);
      }

      case 'ContentfulSectionCarousel': {
        return ContentfulSectionCarousel(section, i, styles, onCtaClick);
      }
      case 'ContentfulComponentCallToAction': {
        return ContentfulComponentCallToAction(section, i, styles);
      }
      case 'ContentfulHalfContentSection': {
        return (
          <HalfAndHalfContent key={i} section={section} extended={!section.imageBackgroundGradient && isCampaignLP} />
        );
      }
      case 'ContentfulComponentMediaGroup': {
        if (section.type === 'Rotating') {
          return <RotatingMedia key={i} section={section} />;
        } else {
          return <LogoSection key={i} section={section} />;
        }
      }

      case 'ContentfulSectionThreeUp': {
        return <ThreeUp center={section.centeredTitle} section={section} animate key={i} />;
      }

      case 'ContentfulSectionG2Quote': {
        return <G2Quote section={section} key={i} />;
      }

      case 'ContentfulSectionZPattern': {
        return <ZPattern section={section} key={i} className={styles.zPatternOverride} />;
      }

      case 'ContentfulSectionTestimonial': {
        return <Testimonial section={section} key={i} />;
      }

      case 'ContentfulSectionAdditionalResources': {
        return <AdditionalResources section={section} key={i} showImage={section.showImages} />;
      }

      case 'ContentfulEmbedJumpLink': {
        return <div key={i} id={section.sectionId} style={{ height: 0 }} />;
      }

      case 'ContentfulComponentRoiCalculator': {
        return <RoiCalculator key={i} section={section} />;
      }

      case 'ContentfulSectionStylizedHeadlineCallout': {
        return <StylizedHeadlineCallout key={i} section={section} />;
      }

      default: {
        return '';
      }
    }
  });
};
